// MyApplauseMarksheetsLeaderboard.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import '../wallet/MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faRankingStar } from '@fortawesome/free-solid-svg-icons';

const MyApplauseMarksheetsLeaderboard = () => {
  const authState = useSelector(state => state.authReducer);
  const userId = authState.user._id
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();

  const [leadersList, setLeadersList] = useState([]);
  const [selectedId, setSelectedId] = useState('');

  
  //Leaderboard
  const fetchList = useCallback(() => {
    const config = {
      url: "/applauseLeaderboard/list100",
      method: "post",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response && Array.isArray(response.leadersList)) {
          setLeadersList(response.leadersList);
        } else {
          console.error("Data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchList();
  }, [authState.isLoggedIn, fetchList]);

  const sortedLeadersList = [...leadersList].sort((a, b) => b.rank - a.rank);

  const handleListView = (_id) => {
    setSelectedId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className='bg-black'>
      <div className='border-b broder-blue-400'>
        <h3 className='text-lg lg:text-lg mt-1 mx-4 text-yellow-200'>🔢 Applause Contest Leaderboard </h3>
      </div>
      <div className="mx-auto min-h-[85vh]">
        <div className="list-container p-4 mt-4">
          {loading ? (
            <Loader />
          ) : (
            <div className='w-full'>
              <div className="flex flex-row justify-between items-center ">
                <div>
                <h3 className='text-2xl mt-1 mx-2 text-white'><FontAwesomeIcon icon={faRankingStar} className="text-red-500 text-4xl mr-2" />Contest Leaders</h3>
                </div>
                <div className='flex flex-row'>
                  <button
                    className='bg-purple-700'
                    onClick={handleCancel}
                    style={{ maxWidth: '150px' }}
                  >
                    Back
                  </button>
                </div>
              </div>
              <div>
                {leadersList && leadersList.length === 0 ? (
                  <div className="flex items-center justify-center text-yellow-300 text-lg h-64">
                    No records found!
                  </div>
                ) : (
                  <>
                    {sortedLeadersList.map((listItem, index) => (
                      <div key={listItem._id} className="bg-gray-600 my-4 p-4 text-white rounded-lg shadow-lg">
                        <div className="flex justify-between items-center mb-2">
                          <span className="font-medium text-white">
                            {index + 1}. {listItem.leaderName}{ ' '}{listItem.leaderCode}{' '}{listItem.leaderAddress}
                          </span>
                          <Tooltip text="View details" position="top">
                            <span className="text-white cursor-pointer" onClick={() => handleListView(listItem._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                        </div>
                        {selectedId === listItem._id && (
                          <div className="bg-gray-100 p-4 text-black rounded-lg shadow-inner">
                            <p><strong>Date:</strong> {formatDateTime(listItem.statusDate)}</p>
                            <p><strong>Details:</strong> {listItem.remarks}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
      <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/about-us" className="hover:text-teal-300">About</Link>
          <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
          <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
          <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
        </div>
      </div>
    </footer>     
  </div>
  );
};

export default MyApplauseMarksheetsLeaderboard;




